import Container from 'react-bootstrap/Container';

function Blog() {
    const updates = [
        {
            date: '10. marts 2026',
            dateIso: '2026-03-10',
            title: 'En tydeligere følelse på forsiden',
            items: [
                'Arbejdet på forsiden handler i øjeblikket mindre om funktioner og mere om stemning, rytme og retning.',
                'Budgetvenlig skal føles som et roligt sted at planlægge hverdagsmad, ikke som en teknisk oversigt over tilbud og valg.',
                'Vi forsøger at lade by, mad og bevægelse hænge bedre sammen, så oplevelsen peger mod et måltid frem for blot et klik.',
                'Det visuelle udtryk bliver derfor justeret med fokus på varme, overskud og en mere redaktionel tone.',
                'Målet er en forside, der både virker praktisk i hverdagen og samtidig føles indbydende, menneskelig og gennemtænkt.'
            ]
        },
        {
            date: '6. marts 2026',
            dateIso: '2026-03-06',
            title: 'Forbedringer af forsiden',
            items: [
                'Forsideteksten er opdateret, så fokus er tydeligere på tilbud i nærområdet.',
                'Standardradius er sat ned til 2 km, og radius-slideren er gjort mere brugbar på mobil.',
                'Eksempel- og informationsafsnit på forsiden er omskrevet for bedre tydelighed.',
                'Headerens Budgetvenlig-tekst fungerer nu som logoet og linker til forsiden.',
                'Klik på logo eller Budgetvenlig sender nu altid brugeren til toppen af siden.',
                'Skriftstilen er opdateret til en mere læsbar font i hele løsningen.'
            ]
        },
        {
            date: '5. marts 2026',
            dateIso: '2026-03-05',
            title: 'Løbende status',
            items: [
                'Header og forside bliver løbende forbedret med fokus på tydeligere navigation og indhold.'
            ]
        }
    ];
    const latestUpdateDate = updates[0]?.date;

    return (
        <Container className="blog-page editorial-page">
            <section className="blog-hero editorial-hero">
                <p className="editorial-kicker">Produktnoter</p>
                <h1 className="editorial-title">Blog</h1>
                <p className="blog-intro editorial-lead">
                    Korte opdateringer om design, opskrifter og vejen mod en roligere måde at planlægge hverdagsmad på.
                </p>
                <div className="editorial-pill-list" aria-label="Blog status">
                    <span>Senest opdateret: {latestUpdateDate}</span>
                    <span>Design</span>
                    <span>Madplaner</span>
                </div>
            </section>
            <div className="blog-updates editorial-card-list">
                {updates.map((update) => (
                    <article className="blog-update-card editorial-card" key={update.date}>
                        <time className="blog-update-date editorial-meta" dateTime={update.dateIso}>{update.date}</time>
                        <h2>{update.title}</h2>
                        <ul>
                            {update.items.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    </article>
                ))}
            </div>
        </Container>
    );
}

export default Blog;
